export const AuthFormActionType = {
   SET_FIRST_NAME: "SET_FIRST_NAME",
   SET_LAST_NAME: "SET_LAST_NAME",
   SET_USER_NAME: "SET_USER_NAME",
   SET_EMAIL: "SET_EMAIL",
   SET_PASSWORD: "SET_PASSWORD",
   SET_CONFIRM_PASSWORD: "SET_CONFIRM_PASSWORD",
   TOGGLE_SHOW_PASSOWRD: "TOGGLE_SHOW_PASSOWRD",
   TOGGLE_SHOW_CONFIRM_PASSOWRD: " TOGGLE_SHOW_CONFIRM_PASSOWRD",
   SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
   SET_LOADING: "SET_LOADING",
   RESET_FORM: "RESET_FROM",
};

Object.freeze(AuthFormActionType);
